import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { UserForExternalActivityPanel } from "../activity/UserForExternalActivityPanel";
import ICalendarFeedsPanel from "../../components/ICalendarFeedsPanel";
import { UserForExternalDetailSection } from "../UserForExternalDetailSection";
import UserOptionsPanel from "UserAdmin/components/UserOptionsPanel";
import { DeactivatedUserDetailSection } from "UserAdmin/components/DeactivatedUserDetailSection";

export const UserForExternalDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalUserToClientDetailFrontModel>();
  const [userSmall, setUserSmall] = React.useState<server.dto.UserSmall>(viewModel.externalUserToClient.user);

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {viewModel.externalUserToClient.lifeCycle === "active" ? <UserForExternalDetailSection
            userToClient={viewModel.externalUserToClient}
            clientConfig={viewModel.clientConfiguration}
            onNameChanged={(firstName, lastName) => {
              setUserSmall({
                ...userSmall,
                firstName,
                lastName,
                fullName: `${firstName} ${lastName}`
              });
            }}
          /> : <DeactivatedUserDetailSection
            userToClient={viewModel.externalUserToClient}
            title={RESX.UserType.ExternalUser}
            environment="external"
          />}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <UserOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            userToClient={viewModel.externalUserToClient}
            userSmall={userSmall}
          />
          {viewModel.externalUserToClient.lifeCycle === "active" && <ICalendarFeedsPanel
            userToClient={viewModel.externalUserToClient}
          />}
          <UserForExternalActivityPanel
            userToClientId={viewModel.externalUserToClient.userToClientId}
            config={viewModel.activityPanelConfig}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
}